var toString = {}.toString;

module.exports = Array.isArray || function (arr) {
  return toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ../~/buffer/~/isarray/index.js
// module id = ../node_modules/buffer/node_modules/isarray/index.js
// module chunks = 1